module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AlignRight_16"],"path":[{"$":{"d":"M11,10v3H2V10h9m1-1H1v5H12V9ZM4,7h8V2H4Zm9,9h2V0H13Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AlignRight_16.svg
// module id = wm2C
// module chunks = 1